import axios from 'axios';
import { getAuthHeader } from './authService';
import API_CONFIG from '../config';

const API_URL = API_CONFIG.BASE_URL;

const getHeaders = () => ({
  ...getAuthHeader(),
  'Content-Type': 'application/json',
  'Accept': 'application/json'
});

export const supplierService = {
  getAllSuppliers: async (params = {}) => {
    try {
      const response = await axios.get(`${API_URL}/suppliers`, {
        headers: getHeaders(),
        params: { page: 0, size: 500, ...params }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching suppliers:', error.response || error);
      throw error;
    }
  },

  getSuppliersByCompany: async (companyId) => {
    try {
      const response = await axios.get(`${API_URL}/suppliers/company/${companyId}`, {
        headers: getHeaders()
      });
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error fetching suppliers:', error.response || error);
      throw error;
    }
  },

  getSupplierById: async (id) => {
    try {
      const response = await axios.get(`${API_URL}/suppliers/${id}`, {
        headers: getHeaders()
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching supplier with ID ${id}:`, error.response || error);
      throw error;
    }
  },

  createSupplier: async (supplierData) => {
    try {
      console.log('Creating supplier with data:', supplierData);
      const response = await axios.post(`${API_URL}/suppliers`, supplierData, {
        headers: getHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error creating supplier:', error.response || error);
      throw error;
    }
  },

  updateSupplier: async (id, supplierData) => {
    try {
      console.log('Updating supplier with data:', supplierData);
      const response = await axios.put(`${API_URL}/suppliers/${id}`, supplierData, {
        headers: getHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error updating supplier:', error.response || error);
      throw error;
    }
  },

  deleteSupplier: async (id) => {
    try {
      const response = await axios.delete(`${API_URL}/suppliers/${id}`, {
        headers: getHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting supplier:', error.response || error);
      throw error;
    }
  },

  existsPhone: async (phone) => {
    try {
      const response = await axios.get(`${API_URL}/suppliers/exists/phone`, {
        params: { phone },
        headers: getHeaders()
      });
      return response.data === true;
    } catch (error) {
      console.error('Error checking supplier phone existence:', error.response || error);
      return false;
    }
  },

  getLatestSupplier: async () => {
    try {
      const response = await axios.get(`${API_URL}/suppliers/latest`, {
        headers: getHeaders()
      });
      // If 204 No Content, response.data might be empty string or null depending on Axios config,
      // but typically 204 has no body.
      if (response.status === 204) return null;
      return response.data;
    } catch (error) {
      console.error('Error fetching latest supplier:', error.response || error);
      return null;
    }
  }
}; 
